import React from 'react'
import { useNavigate } from 'react-router-dom'
import { LoginForm } from '../components/LoginForm'

const LoginPage: React.FC = () => {
  const navigate = useNavigate()

  const handleLoginSuccess = () => {
    navigate('/')
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold text-gray-900">ASF Staff Login</h1>
          <p className="mt-2 text-sm text-gray-600">
            Enter your email to receive a verification code
          </p>
        </div>
        <LoginForm onSuccess={handleLoginSuccess} />
      </div>
    </div>
  )
}

export default LoginPage
